module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"connect_to":"Connect to"},"fr":{"connect_to":"Connectez-vous pour accéder à"}}')
  delete Component.options._Ctor
}
